import { useContext } from "react";
import AppContext from "../contexts/AppContext";
import useRedirect from "./useRedirect";
import routes from "../constants/Routes";
import GLOBAL from "../global";
import { useTenantFeatures } from "../features/tenantFeatures/useTenantFeature";

const useD2C = () => {
    const { userInfo, authenticated } = useContext(AppContext);
    const { redirect } = useRedirect();
    const IsD2CEnabled = userInfo?.Permissions?.IsD2CEnabled || false;
    const { isAthleteEnabled } = useTenantFeatures();

    const handleIsD2CEnabled = () => {
        let isRedirected = false;

        if(!IsD2CEnabled) {
            if(authenticated) {
                if (isAthleteEnabled) {
                    redirect(`${routes.myAssessments}/false`);
                } else {
                    redirect(routes.dashboard);
                }
            } else {
                redirect(routes.landing);
            }

            isRedirected = true;
        }

        return isRedirected;
    }

    return { IsD2CEnabled, handleIsD2CEnabled };
}

export default useD2C;
